<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
	<path d="M12,4V0H0v12h4v4h12V4H12z M1,1h10v10H1V1z" />
</svg>
</template>